export default "__VITE_ASSET__B$m$_Jh6__"